var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24cca7",
    style: {
      fill: "var(--color1, #24cca7)"
    },
    d: "M3.755 7.619l16.211-4.537-0.859-1.779c-0.562-1.157-1.932-1.634-3.060-1.058l-14.513 7.375h2.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24cca7",
    style: {
      fill: "var(--color1, #24cca7)"
    },
    d: "M24.813 3.048c-0.195 0-0.391 0.029-0.586 0.087l-15.012 4.484h18.431l-0.693-2.779c-0.266-1.083-1.163-1.793-2.14-1.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a56e2",
    style: {
      fill: "var(--color2, #4a56e2)"
    },
    d: "M28.36 8.573h-26.559c-0.568 0-1.074 0.26-1.405 0.67-0.151 0.189-0.266 0.406-0.331 0.645-0.040 0.15-0.065 0.307-0.065 0.467v19.862c0 0.984 0.805 1.783 1.797 1.783h26.559c0.992 0 1.797-0.799 1.797-1.783v-4.973h-10.662c-1.685 0-3.054-1.358-3.054-3.030v-3.964c0-0.82 0.331-1.565 0.866-2.111 0.474-0.485 1.11-0.813 1.822-0.895 0.119-0.014 0.241-0.021 0.363-0.021h10.666v-4.867c0.004-0.984-0.801-1.783-1.793-1.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a56e2",
    style: {
      fill: "var(--color2, #4a56e2)"
    },
    d: "M31.414 16.926c-0.18-0.164-0.392-0.289-0.629-0.371-0.183-0.061-0.377-0.096-0.582-0.096h-10.712c-0.992 0-1.797 0.799-1.797 1.783v3.968c0 0.984 0.805 1.783 1.797 1.783h10.712c0.205 0 0.399-0.036 0.582-0.096 0.237-0.078 0.449-0.207 0.629-0.371 0.359-0.324 0.586-0.795 0.586-1.316v-3.968c0-0.52-0.226-0.991-0.586-1.316zM23.243 20.581c0 0.492-0.402 0.891-0.898 0.891h-0.596c-0.496 0-0.898-0.399-0.898-0.891v-0.592c0-0.285 0.133-0.538 0.345-0.699 0.155-0.118 0.345-0.193 0.553-0.193h0.596c0.496 0 0.898 0.399 0.898 0.891v0.592z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-account_box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2H2C.89 0 0 .9 0 2Zm12 4c0 1.66-1.34 3-3 3S6 7.66 6 6s1.34-3 3-3 3 1.34 3 3Zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H3v-1Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-lock"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7h-1V5c0-2.76-2.24-5-5-5S3 2.24 3 5v2H2C.9 7 0 7.9 0 9v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2Zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Zm3.1-9H4.9V5c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-email"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0H2C.9 0 .00999999.9.00999999 2L0 14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm0 4-8 5-8-5V2l8 5 8-5v2Z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-down",
    viewBox: "0 0 58 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.9091,
    d: "M2.909 2.909l26.182 26.182 26.182-26.182"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.545 2.182c-2.41 0-4.364 1.954-4.364 4.364v18.909c0 2.41 1.954 4.364 4.364 4.364h18.909c2.41 0 4.364-1.954 4.364-4.364v-18.909c0-2.41-1.954-4.364-4.364-4.364h-18.909zM13.77 17.716v5.961h-4.97v-7.948h-2.982l9.939-8.941 9.939 8.941h-2.982v7.948h-4.97v-5.961h-3.976z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-currency",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.545 2.182c-2.41 0-4.364 1.954-4.364 4.364v18.909c0 2.41 1.954 4.364 4.364 4.364h18.909c2.41 0 4.364-1.954 4.364-4.364v-18.909c0-2.41-1.954-4.364-4.364-4.364h-18.909zM13.638 13.526c0 0.86 0.661 1.412 2.715 1.946s4.253 1.412 4.253 3.982c0 1.855-1.403 2.878-3.167 3.212v1.946h-2.715v-1.964c-1.737-0.371-3.222-1.484-3.33-3.466h1.991c0.1 1.068 0.833 1.9 2.697 1.9 2 0 2.443-0.995 2.443-1.62 0-0.842-0.452-1.638-2.715-2.181-2.525-0.606-4.253-1.647-4.253-3.737 0-1.747 1.412-2.887 3.167-3.267v-1.955h2.715v1.982c1.891 0.462 2.841 1.891 2.905 3.448h-2c-0.054-1.131-0.651-1.9-2.262-1.9-1.529 0-2.443 0.688-2.443 1.674z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-statistics",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.545 2.182h18.909c2.41 0 4.364 1.954 4.364 4.364v18.909c0 2.41-1.954 4.364-4.364 4.364h-18.909c-2.41 0-4.364-1.954-4.364-4.364v-18.909c0-2.41 1.954-4.364 4.364-4.364zM23.636 14.222c0.933 0 1.697-0.8 1.697-1.778s-0.764-1.778-1.697-1.778c-0.933 0-1.697 0.8-1.697 1.778 0 0.16 0.017 0.311 0.059 0.453l-3.012 3.164c-0.136-0.044-0.288-0.062-0.441-0.062s-0.305 0.018-0.441 0.062l-2.164-2.267c0.042-0.142 0.059-0.302 0.059-0.462 0-0.978-0.764-1.778-1.697-1.778s-1.697 0.8-1.697 1.778c0 0.16 0.017 0.32 0.059 0.462l-3.869 4.044c-0.136-0.044-0.28-0.062-0.433-0.062-0.933 0-1.697 0.8-1.697 1.778s0.764 1.778 1.697 1.778c0.933 0 1.697-0.8 1.697-1.778 0-0.16-0.017-0.311-0.059-0.453l3.861-4.053c0.136 0.044 0.288 0.062 0.441 0.062s0.305-0.018 0.441-0.062l2.164 2.267c-0.042 0.142-0.059 0.302-0.059 0.462 0 0.978 0.764 1.778 1.697 1.778s1.697-0.8 1.697-1.778c0-0.16-0.017-0.32-0.059-0.462l3.021-3.156c0.136 0.044 0.28 0.062 0.433 0.062z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close-cross",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.333 8.547l-1.88-1.88-7.453 7.453-7.453-7.453-1.88 1.88 7.453 7.453-7.453 7.453 1.88 1.88 7.453-7.453 7.453 7.453 1.88-1.88-7.453-7.453 7.453-7.453z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.051 23.237h2.499v4.997c0 2.067-1.681 3.748-3.748 3.748h-15.054c-2.066 0-3.748-1.681-3.748-3.748v-24.486c0-2.066 1.681-3.748 3.748-3.748h15.054c2.067 0 3.748 1.681 3.748 3.748v4.997h-2.499v-4.997c0-0.689-0.56-1.249-1.249-1.249h-15.054c-0.689 0-1.249 0.561-1.249 1.249v24.486c0 0.689 0.561 1.249 1.249 1.249h15.054c0.689 0 1.249-0.561 1.249-1.249v-4.997zM26.111 10.102l-1.767 1.767 2.873 2.874h-16.161v2.499h16.161l-2.873 2.873 1.767 1.767 5.889-5.889-5.889-5.89z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 18 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9H4V11H6V9ZM10 9H8V11H10V9ZM14 9H12V11H14V9ZM16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V7H16V18Z",
    fill: "#4A56E2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.2ff8c251446e20eb300ae7b5c4b8d862.svg";
export { ForwardRef as ReactComponent };